<template>

    <b-row align-v="center" class="login-cover-caption">

        <b-col align-self="center" cols="3" style="max-width: 320px">
            <b-row class="form-lostpassword-heading">
                Пожалуйста, введите E-mail, который вы использовали для входа в приложение
            </b-row>

            <b-row class="mb-20">
                <b-input v-model="email" placeholder="Email" />
            </b-row>

            <button class="btn btn-lg btn-success btn-block medium" 
					type="submit" 
					@click="restore">

				Восстановить пароль
			</button>

            <div class="lost-line"> </div>

            <b-row class="lost-description">
                Если вы не помните E-mail для авторизации,
                обратитесь к руководителю или администратору системы
            </b-row>
        </b-col>

    </b-row>
</template>
<script>

import dialogService from '@/services/dialog.service'
import apiService from '@/services/api.service'

export default {
    data: function() {
        return {
            email: null
        }
    },
    methods: {
        restore: function() {
            if(!this.email) {
                dialogService.showAlert('Предупреждение', 'Введите Email');
                return;
            }

            apiService.Account.PostForgotPassword(this.email)
                .then(response => {
                    dialogService.showAlert('Сообщение', 'Письмо для восстановления пароля успешно отправлено на почту.');
                })
                .catch(error => console.log(error));
        }
    }
}
</script>